import React from 'react';
import './peoplelabel.css'

const Label = (props) => {
  return ( <div className={props.class}>
    <img src={props.labelimg} alt="" />
    <div className='label_inside'>
      <p className='labeltitle'>{props.labeltitle}</p>
      <p className='labeltext'>{props.labeltext}
      </p>
    </div>
  </div> );
}
 
export default Label;